import React, { useState, useRef, FC, useEffect } from 'react'

const EditableInput: FC<{
  value: string
  // onRename?: any
  onChange: any
  // setInputFocused?: (focused: boolean) => void
}> = ({ value, onChange }) => {
  const [isEditing, setIsEditing] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)
  // const [inputValue, setInputValue] = useState(value)

  useEffect(() => {
    if (isEditing) {
      inputRef.current?.focus()
    }
  }, [isEditing])

  // const handleBlur = () => {
  //   setIsEditing(false)
  //   onRename(inputValue)
  //   setTimeout(() => {
  //     setInputFocused(false)
  //   }, 300)
  // }
  const handleBlur = () => {
    setIsEditing(false)
  }

  const handleClick = () => {
    setIsEditing(true)
  }

  // const handleFocus = () => {
  //   setInputFocused(true)
  // }

  return (
    <div onClick={handleClick} className='cursor-text inline-block'>
      {isEditing ? (
        // <input
        //   ref={inputRef}
        //   type='text'
        //   value={inputValue}
        //   onChange={(e) => setInputValue(e.target.value)}
        //   // onBlur={handleBlur}
        //   onFocus={handleFocus}
        //   className='border border-blue-300 px-1 py-1 ml-1 rounded outline-none !focus:border-blue-300'
        // />
        <input
          ref={inputRef}
          type='text'
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={handleBlur}
          // onFocus={handleFocus}
          className='border border-blue-300 px-1 py-1 ml-1 rounded outline-none !focus:border-blue-300'
        />
      ) : (
        <span className='px-2 py-1 text-md'>{value}</span>
      )}
    </div>
  )
}

export default EditableInput
